// src/pages/MemberViewModal.jsx
import React from "react";
import { X, UserCheck, UserX } from "lucide-react";
import { clsx } from "clsx";

const STATUS_STYLE = {
  A: "bg-green-50 text-green-700",
  B: "bg-amber-50 text-amber-700",
  C: "bg-slate-100 text-slate-500",
};
const STATUS_LABEL = { A: "정상", B: "정지", C: "삭제" };
const STATUS_ICON = {
  A: <UserCheck className="h-3 w-3" />,
  B: <UserX className="h-3 w-3" />,
  C: <UserX className="h-3 w-3" />,
};

export function MemberViewModal({ member, onClose, onEdit }) {
  if (!member) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/40 backdrop-blur-sm" onClick={onClose} />
      
      <div className="relative w-full max-w-md rounded-2xl bg-white shadow-2xl animate-in fade-in zoom-in-95 duration-200">
        <div className="flex items-center justify-between border-b border-slate-200 px-6 py-4">
          <h3 className="text-base font-bold text-slate-800">회원 상세 정보</h3>
          <button onClick={onClose} className="p-1.5 rounded-lg text-slate-400 hover:bg-slate-100 hover:text-slate-600 transition-colors">
            <X className="h-5 w-5" />
          </button>
        </div>
        
        <div className="p-6">
          {/* Profile Header */}
          <div className="flex items-center gap-4 mb-6 pb-5 border-b border-slate-100">
            <div className="flex h-14 w-14 items-center justify-center rounded-full bg-indigo-600 text-white text-xl font-bold shadow-md">
              {member.memberNm?.[0] || 'U'}
            </div>
            <div>
              <p className="text-lg font-bold text-slate-800">{member.memberNm}</p>
              <div className="flex items-center gap-2 mt-1">
                <span className={clsx("inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium", member.roleId === 'R0' ? "bg-purple-50 text-purple-700" : "bg-teal-50 text-teal-700")}>
                  {member.roleName}
                </span>
                <span className={clsx("inline-flex items-center gap-1 rounded-full px-2.5 py-0.5 text-xs font-medium", STATUS_STYLE[member.status] || STATUS_STYLE.A)}>
                  {STATUS_ICON[member.status] || STATUS_ICON.A} {STATUS_LABEL[member.status] || "정상"}
                </span>
              </div>
            </div>
          </div>

          {/* Details List */}
          <div className="space-y-4">
            {[
              { label: "아이디", value: member.memberId, mono: true },
              { label: "소속 부서", value: member.branchName || '-' },
              { label: "연락처", value: member.phone || '-' },
              { label: "이메일", value: member.email || '-' },
              { label: "가입(등록)일", value: member.regDtm },
              { label: "배정 업체 수", value: member.roleId === 'R0' ? '-' : `${member.assignedCount}개` },
              { label: "수행요원 ID", value: member.staffId || '-', mono: true },
              { label: "수행요원 이름", value: member.staffNm || '-', mono: true },
            ].map(({ label, value, mono }, idx) => (
              <div key={idx} className="flex items-center gap-4">
                <span className="w-28 shrink-0 text-xs font-semibold text-slate-500">{label}</span>
                <span className={clsx("text-sm text-slate-800", mono && "font-mono font-medium")}>{value}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="flex items-center justify-end gap-3 border-t border-slate-200 px-6 py-4 bg-slate-50 rounded-b-2xl">
          <button onClick={onClose} className="h-10 rounded-lg border border-slate-300 bg-white px-5 text-sm font-medium text-slate-700 hover:bg-slate-50 transition-colors">
            닫기
          </button>
          <button onClick={onEdit} className="h-10 rounded-lg bg-amber-500 px-5 text-sm font-medium text-white hover:bg-amber-600 transition-colors">
            수정하기
          </button>
        </div>
      </div>
    </div>
  );
}